import React from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { Titled } from 'react-titled';
import { useTranslation } from 'react-i18next';
import withRoute, {
  AnonymousRoute,
  withProtectedRoute,
} from 'components/common/Route';
import Error from 'routes/Error';
import SignUp from './SignUp';
import { Provider as SignUpProvider } from './context';
import Success from './Success';
import SelectAccountType from './SelectAccountType';
import PostVerification from './PostVerification';
import CompanyInfo from './CompanyInfo';
import CompanyInfoLanding from './CompanyInfoLanding';
import PartnerInviteSuccess from './PartnerInviteSuccess';
import InviteDisplayPanel from 'components/SignUp/InviteDisplayPanel';

export const SignUpLayout = () => {
  const { t } = useTranslation();
  return (
    <SignUpProvider>
      <Titled title={title => `${t('signUp.pageTitle')} | ${title}`}>
        <Outlet />
      </Titled>
    </SignUpProvider>
  );
};

const routes: RouteObject[] = [
  {
    path: '*',
    Component: () => (
      <AnonymousRoute>
        <SignUp />
      </AnonymousRoute>
    ),
  },
  {
    path: 'get-started',
    Component: () => (
      <AnonymousRoute>
        <SelectAccountType />
      </AnonymousRoute>
    ),
  },
  {
    path: 'success-invite',
    Component: () => (
      <AnonymousRoute>
        <PartnerInviteSuccess />
      </AnonymousRoute>
    ),
  },
  {
    path: 'success',
    Component: () => (
      <AnonymousRoute>
        <Success />
      </AnonymousRoute>
    ),
  },
  {
    path: 'company-info',
    Component: () => withProtectedRoute(CompanyInfo),
  },
  {
    path: 'company-info/landing',
    Component: () => withProtectedRoute(CompanyInfoLanding),
  },
  {
    path: 'verification-success',
    Component: () => withProtectedRoute(PostVerification),
  },
  {
    path: 'accept-invite',
    Component: () => withRoute(SignUp),
  },
  {
    path: 'invite',
    Component: () => (
      <AnonymousRoute>
        <InviteDisplayPanel />
      </AnonymousRoute>
    ),
  },
  {
    path: '*',
    Component: () => (
      <AnonymousRoute>
        <Error />
      </AnonymousRoute>
    ),
  },
];

export default routes;
